module.exports = __webpack_public_path__ + "static/media/export-cost-plan.be0ba7fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/costPlan/assets/export-cost-plan.svg
// module id = 7540
// module chunks = 0